import { useState } from "react";
import { Page, Resource, TestDefinition } from "../../../api";
import { PageContext } from "./PageContext";

export function PageProvider({ children }: { children: React.ReactNode }) {
  const [pages, setPages] = useState<Page[]>(
    localStorage.getItem(Resource.Page) ? JSON.parse(localStorage.getItem(Resource.Page)!) : [],
  );
  const [tests, setTests] = useState<TestDefinition[]>(
    localStorage.getItem(Resource.TestDefinition)
      ? JSON.parse(localStorage.getItem(Resource.TestDefinition)!)
      : [],
  );

  const setPage = (pages: Page[]) => {
    setPages(pages);
    localStorage.setItem(Resource.Page, JSON.stringify(pages));
  };

  const setTest = (tests: TestDefinition[]) => {
    setTests(tests);
    localStorage.setItem(Resource.TestDefinition, JSON.stringify(tests));
  };

  return (
    <PageContext.Provider value={{ pages, setPages: setPage, tests, setTests: setTest }}>
      {children}
    </PageContext.Provider>
  );
}
